import { Col, Divider, Row, Spin } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import orderAPI from '~/api/OrderAPI';
import { SVGS } from '~/assets/assetsPath';
import DetailInfoClientOrder from '~/components/DetailInfoClientOrder';
import DetailInfoOrder from '~/components/DetailInfoOrder';
import config from '~/config';
import CardAboutMe from '../../components/card-about-me';
import styles from './DetailOrder.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const DetailOrder = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { order_id } = useParams();
    const [orderInfo, setOrderInfo] = useState({});

    const handleGetOrderInfo = async () => {
        try {
            setIsLoading(true);
            let order = {};
            const params = {
                fields: '["$all", {"branch": ["$all"]}, {"order_items":["$all", {"product": ["$all", {"category": ["$all"]}]}]}]',
            };
            const res = await orderAPI.getOneOrderAPI(order_id, params);

            if (res.code === 200) {
                order = { ...res.results.object };
            }

            setOrderInfo(order);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        handleGetOrderInfo();
        //eslint-disable-next-line
    }, [order_id]);
    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinDonHang');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 3, children: null }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('right_section')}>
                    <div className={cx('right_container')}>
                        {isLoading ? (
                            <Row justify="center">
                                <Spin />
                            </Row>
                        ) : (
                            <>
                                {orderInfo?.id ? (
                                    <>
                                        <Row className={cx('nav')}>
                                            <Col xs={8}>
                                                <Row align="middle" className={cx('come_back')}>
                                                    <img
                                                        src={SVGS.IconArrowLeft}
                                                        alt=""
                                                        onClick={() => navigate(config.routes.orders)}
                                                    />
                                                    <span
                                                        className={cx('text')}
                                                        onClick={() => navigate(config.routes.orders)}
                                                    >
                                                        Return
                                                    </span>
                                                </Row>
                                            </Col>
                                            <Col xs={16}>
                                                <Row align="middle" justify="end">
                                                    Code orders:
                                                    <span className={cx('code_service')}>#{orderInfo.order_code}</span>
                                                </Row>
                                                <Row align="middle" style={{ marginTop: '2px' }} justify="end">
                                                    Order type:
                                                    <span className={cx('order_type')}>
                                                        {orderInfo.order_type === 'PRODUCT'
                                                            ? 'Product'
                                                            : 'Service pack'}
                                                    </span>
                                                </Row>
                                                <Row justify="end" className={cx('status')}>
                                                    {orderInfo.activity === 'WAITING' && <span>Waiting for confirmation</span>}
                                                    {orderInfo.activity === 'CONFIRMED' && <span>Waiting for pickup</span>}
                                                    {orderInfo.activity === 'PROCESSING' && <span>Delivering</span>}
                                                    {orderInfo.activity === 'COMPLETED' && <span>Received</span>}
                                                    {orderInfo.activity === 'CANCELED' && <span>Canceled</span>}
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
                                        <DetailInfoClientOrder item={orderInfo} />
                                        <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
                                        <DetailInfoOrder item={orderInfo} handleGetOrderInfo={handleGetOrderInfo} />
                                    </>
                                ) : (
                                    <Row justify="center" className={cx('service_no_exist')}>
                                        Order does not exist
                                    </Row>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailOrder;
